import { RequestSender } from "./helpers";

async function logout(request: RequestSender): Promise<void> {
  await request<any>("get", "/profile/logout");
}

export default logout;
